<div class="ils-player">
  <app-busy-spinner [busyKey]="busyKey" [startDelay]="0"></app-busy-spinner>
  <div class="title-bar">
    <app-title-bar></app-title-bar>
  </div>
  <mat-drawer-container autosize class="ils-player-drawer-container">
    <mat-drawer #phasesDrawer class="phase-list" mode="side" opened>
      <app-phase-list></app-phase-list>
    </mat-drawer>

    <div
      class="phase-content"
      id="content-width-indicator"
      [class.with-navigation-bar]="(ilsModelService.enableNavigationButtons$ | async)"
    >
      @switch (ilsModelService.ilsStatus$ | async) {
        @case (IlsStatus.Error) {
          <div class="ils-error">
            {{ 'errors.' + ilsModelService.errorMessage | translate }}
          </div>
        }
        @case (IlsStatus.Loaded) {
          <div class="collapse-control">
            <div class="collapse-phase-list">
              @if (this.phasesDrawer!.opened) {
                <button
                  (click)="togglePhasesDrawer()"
                  [matTooltip]="'ilsPlayer.hidePhaseList' | translate"
                  aria-label="'ilsPlayer.hidePhaseList' | translate"
                  class="collapse-global-apps-button"
                  mat-icon-button
                >
                  <span class="material-symbols-outlined">left_panel_close</span>
                </button>
              }
              @if (!this.phasesDrawer!.opened) {
                <button
                  (click)="togglePhasesDrawer()"
                  [matTooltip]="'ilsPlayer.showPhaseList' | translate"
                  aria-label="'ilsPlayer.showPhaseList' | translate"
                  class="collapse-global-apps-button"
                  mat-icon-button
                >
                  <span class="material-symbols-outlined">left_panel_open</span>
                </button>
              }
            </div>
            @if (showGlobalContentList) {
              <div class="collapse-global-apps">
                @if (this.globalAppsDrawer!.opened) {
                  <button
                    (click)="toggleGlobalAppsDrawer()"
                    [matTooltip]="'ilsPlayer.hideGlobalApps' | translate"
                    aria-label="'ilsPlayer.hideGlobalApps' | translate"
                    class="collapse-global-apps-button"
                    mat-icon-button
                  >
                    <span class="material-symbols-outlined">right_panel_close</span>
                  </button>
                }
                @if (!this.globalAppsDrawer!.opened) {
                  <button
                    (click)="toggleGlobalAppsDrawer()"
                    [matTooltip]="'ilsPlayer.showGlobalApps' | translate"
                    aria-label="'ilsPlayer.showGlobalApps' | translate"
                    class="collapse-global-apps-button"
                    mat-icon-button
                  >
                    <span class="material-symbols-outlined">right_panel_open</span>
                  </button>
                }
              </div>
            }
          </div>
          <app-phase-content></app-phase-content>
          @if (ilsModelService.enableNavigationButtons$ | async) {
            <div class="phase-navigation-bar">
              <button
                (click)="goToPreviousPhase()"
                [disabled]="!hasPreviousPhase"
                class="phase-navigation-button"
                color="primary"
                mat-flat-button
                [matTooltip]="'ilsPlayer.previousPhase.tooltip' | translate"
              >
                <span class="phase-navigation-button-content">
                  <mat-icon>arrow_back</mat-icon>
                  <span>{{ 'ilsPlayer.previousPhase' | translate }}</span>
                </span>
              </button>
              <button
                (click)="goToNextPhase()"
                [disabled]="!hasNextPhase"
                class="phase-navigation-button"
                color="primary"
                mat-flat-button
                [matTooltip]="'ilsPlayer.nextPhase.tooltip' | translate"
              >
                <span class="phase-navigation-button-content">
                  <span>{{ 'ilsPlayer.nextPhase' | translate }}</span>
                  <mat-icon>arrow_forward</mat-icon>
                </span>
              </button>
            </div>
          }
        }
      }
    </div>

    <mat-drawer
      #globalAppsDrawer
      [ngClass]="{ 'no-global-content': !showGlobalContentList }"
      class="global-apps-list"
      mode="side"
      opened
      position="end"
    >
      <app-content-list [contentList]="globalContentList"></app-content-list>
    </mat-drawer>
  </mat-drawer-container>
</div>
